<template>
  <div>
    <div v-if="media">
      <div v-if="isEmbed" class="text-center">
        <q-img
          :src="media.thumbnail"
          :ratio="aspectRatio"
          :class="{'cursor-pointer': canShowPost}"
          @click="openPostModal"
        />
        <q-btn
          label="View Video"
          class="full-width"
          flat no-caps
          @click="openEmbedModal"
        />
      </div>
      <div v-else-if="isVideo">
        <video
          :src="media.url"
          preload="metadata"
          width="100%"
          controls
        />
        <q-btn
          v-if="hasFeat('TRANSCRIBE')"
          flat
          round
          @click="openPostTranscriptModal"
          title="View Transcript"
          style="position: absolute; top: 10px; right: 10px; z-index: 10;"
        >
          <q-icon name="fa fa-closed-captioning" size="1.5rem" />
        </q-btn>
      </div>
      <q-img
        v-else
        :src="media.url"
        :ratio="aspectRatio"
        :class="{'cursor-pointer': canShowPost}"
        @click="openPostModal"
      />
    </div>
    <div v-else class="q-pa-sm text-center text-grey-6">
      <em>This post has no media.</em>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import { Media } from '@/type';
import { hasFeat } from '@/social/config';
import PostTranscriptModal from '../PostTranscriptModal.vue';
import ViewEmbedPostModal from '../ViewEmbedPostModal.vue';
import { PostSearchMatchRule } from '../search/types';

export default defineComponent({
  props: {
    postId: Number,
    media: Object as () => Media,
    aspectRatio: Number,
    highlightTranscript: {
      type: Array as () => PostSearchMatchRule[],
      default: () => [],
    },
  },
  computed: {
    canShowPost(): boolean {
      return Number.isInteger(this.postId);
    },
    type(): string|null {
      if (this.media) return this.media.type;
      return null;
    },
    isEmbed(): boolean {
      return (this.type === 'embed');
    },
    isVideo(): boolean {
      return (this.type === 'video');
    },
  },
  methods: {
    hasFeat,
    async openPostModal() {
      if (this.canShowPost) {
        const { default: PostModal } = await import('../PostModal.vue');
        openModal(PostModal, { parent: this, postId: this.postId });
      }
    },
    openPostTranscriptModal() {
      openModal(PostTranscriptModal, {
        parent: this,
        postId: this.postId,
        highlight: this.highlightTranscript,
      });
    },
    openEmbedModal() {
      openModal(ViewEmbedPostModal, { parent: this, media: this.media });
    },
  },
});
</script>
